import type { YMapCenterLocation, YMapZoomLocation } from '@yandex/ymaps3-types/imperative/YMap';
import { type GeoObject } from '../../api/geoCoder';
import { parseCoordinates } from '../parseCoordinates';
import { DEFAULT_POINT, ZOOM } from './constants';

export const buildYMapLocation = (geoObject?: GeoObject): YMapZoomLocation & YMapCenterLocation => {
    if (geoObject) {
        const [longitude, latitude] = parseCoordinates(geoObject.Point?.pos);
        const kind = geoObject.metaDataProperty.GeocoderMetaData.kind;

        return {
            zoom: ZOOM[kind] || ZOOM.default,
            center: [longitude, latitude],
        };
    }

    return DEFAULT_POINT;
};
